var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 24H3V23H21V24Z",
    fill: "#FCFF62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 23H2V22H3V23Z",
    fill: "#FCFF62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 23H21V22H22V23Z",
    fill: "#FCFF62"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22H1V21H2V22Z",
    fill: "#FCFF62"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23 22H22V21H23V22Z",
    fill: "#FCFF62"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 21H0V3H1V21Z",
    fill: "#FCFF62"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21H23V3H24V21Z",
    fill: "#FCFF62"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2 3H1V2H2V3Z",
    fill: "#FCFF62"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23 3H22V2H23V3Z",
    fill: "#FCFF62"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3 2H2V1H3V2Z",
    fill: "#FCFF62"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22 2H21V1H22V2Z",
    fill: "#FCFF62"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21 1H3V0H21V1Z",
    fill: "#FCFF62"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.125 13.0003H12V13.9999H11.125V15.0002H10.25V15.9998H9.375V17.0001H8.5V17.9997H7.625V19H5V17.9997H5.875V17.0001H6.75V15.9998H7.625V15.0002H8.5V13.9999H9.375V13.0003H10.25V12H11.125V13.0003Z",
    fill: "#FCFF62"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19 19H15.5V17.9997H18.125V17.0001H19V19Z",
    fill: "#FCFF62"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 17.9997H14.625V17.0001H15.5V17.9997Z",
    fill: "#FCFF62"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 17.0001H13.75V15.9998H14.625V17.0001Z",
    fill: "#FCFF62"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 17.0001H17.25V15.9998H18.125V17.0001Z",
    fill: "#FCFF62"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 15.9998H12.875V15.0002H13.75V15.9998Z",
    fill: "#FCFF62"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 15.9998H16.375V15.0002H17.25V15.9998Z",
    fill: "#FCFF62"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M12.875 15.0002H12V13.9999H12.875V15.0002Z",
    fill: "#FCFF62"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M16.375 15.0002H15.5V13.9999H16.375V15.0002Z",
    fill: "#FCFF62"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 13.9999H14.625V13.0003H15.5V13.9999Z",
    fill: "#FCFF62"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 13.0003H13.75V12H14.625V13.0003Z",
    fill: "#FCFF62"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 12H9.375V11.0004H10.25V12Z",
    fill: "#FCFF62"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M19 6.00033H18.125V6.99989H17.25V8.00022H16.375V8.99978H15.5V10.0001H14.625V10.9997H13.75V12H12.875V10.9997H12V10.0001H12.875V8.99978H13.75V8.00022H14.625V6.99989H15.5V6.00033H16.375V5H19V6.00033Z",
    fill: "#FCFF62"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 11.0004L8.5 10.9997V10.0001H9.375V11.0004Z",
    fill: "#FCFF62"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10.0001H7.625V8.99978H8.5V10.0001Z",
    fill: "#FCFF62"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.0001H11.125V8.99978H12V10.0001Z",
    fill: "#FCFF62"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M7.625 8.99978H6.75V8.00022H7.625V8.99978Z",
    fill: "#FCFF62"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M11.125 8.99978H10.25V8.00022H11.125V8.99978Z",
    fill: "#FCFF62"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 6.99989V8.00022H5.875V6.99989H6.75Z",
    fill: "#FCFF62"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 8.00022H9.375V6.99989H10.25V8.00022Z",
    fill: "#FCFF62"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 6.00033H5.875V6.99989H5V5H8.5V6.00033Z",
    fill: "#FCFF62"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 6.99989H8.5V6.00033H9.375V6.99989Z",
    fill: "#FCFF62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.ecbc2e6fe62845641ecacc18767f21fb.svg";
export { ForwardRef as ReactComponent };